'use client';
import { jsx } from 'react/jsx-runtime';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, i = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(o = 0; o < n.length; o++)t = n[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (i[t] = e[t]);
    }
    return i;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, i = {}, n = Object.keys(e);
    for(o = 0; o < n.length; o++)t = n[o], r.indexOf(t) >= 0 || (i[t] = e[t]);
    return i;
}
let i = renderWithRef('ThumbnailsHeroImagesSlidesContainer', null, (r, o)=>{
    var { children: i } = r;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: [
            'swan-thumbnails-hero-images-slides'
        ],
        props: _object_without_properties(r, [
            "children"
        ]),
        children: i
    });
});
const ThumbnailsHeroImagesSlidesContainer = deprecatedComponent({
    description: 'Use AdaptiveCarousel instead',
    displayName: 'ThumbnailsHeroImagesSlidesContainer',
    root: i
});

export { ThumbnailsHeroImagesSlidesContainer };
